import { render, staticRenderFns } from "./EditEventDialog.vue?vue&type=template&id=c0c29bb8&scoped=true"
import script from "./EditEventDialog.vue?vue&type=script&lang=js"
export * from "./EditEventDialog.vue?vue&type=script&lang=js"
import style0 from "./EditEventDialog.vue?vue&type=style&index=0&id=c0c29bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c29bb8",
  null
  
)

export default component.exports